export default "__VITE_ASSET__BBYYSdQf__"